import React from 'react';
import {OauthAuthorizationTokens} from '@practicegenius/register-account/src/data/types';
import {usePhpJs} from '../../../utils/php-js';
import {BaseScreen} from '../../../components/screens/BaseScreen';
import {CenteredWrapper} from '../../../components/screens/layout';
import {SvgImage} from '../../../components/SvgImage/SvgImage';
import {loginWithOauthAccessTokens} from '../../../http/login';

const IncompleteRegistration = ({token}: {token?: string}) => (
  <BaseScreen
    helmetTitle="Finish Registration"
    headerTitle="Register New Account"
    title="Let's finish registering your account"
    actionButtons={[
      {
        children: 'Finish Registering',
        href: `/account/register/link-a-practice${
          token ? `?token=${String(token)}` : ''
        }`,
        id: 'login_button',
      },
    ]}
  >
    <p>The account associated with this email is not set up.</p>
    <p>Let's finish registering so you can start earning rewards.</p>
  </BaseScreen>
);

const AlreadyRegisteredButCannotLogIn = ({
  identifier,
}: {
  identifier: string;
}) => (
  <BaseScreen
    helmetTitle="You're Already Registered"
    headerTitle="Register New Account"
    title="You're already registered!"
    actionButtons={[
      {
        children: 'Login',
        href: `/login?user=${identifier}`,
        id: 'login_button',
      },
    ]}
  >
    <p>You joined RewardsHub with {identifier}. Please use that to log in.</p>
  </BaseScreen>
);

const AlreadyRegisteredAndCanLogIn = ({
  authorization,
}: {
  authorization: OauthAuthorizationTokens;
}) => {
  const goToAccount = async () => {
    try {
      const {redirect} = await loginWithOauthAccessTokens(authorization);

      /**
       * Login unfortunately sends down either a fully qualified url with
       * protocol, or a relative url that may be missing the "/" prefix.
       */
      window.location.href = /^http/.test(redirect)
        ? redirect
        : `/${redirect}`.replace('//', '/');
    } catch (error) {
      alert('Something went wrong, please try logging in again.');

      window.location.href = '/login';
    }
  };

  return (
    <BaseScreen
      helmetTitle="You're Already Registered"
      headerTitle="Register New Account"
      title="Email verified!"
      instructions="Congrats, your email is verified.  Click below to go to your account."
      actionButtons={[
        {
          onClick: goToAccount,
          children: 'Go To My Account',
          id: 'login_button',
        },
      ]}
    >
      <CenteredWrapper>
        <SvgImage name="registrationSuccess" />
      </CenteredWrapper>
    </BaseScreen>
  );
};

const states = {
  INCOMPLETE_REGISTRATION: 'INCOMPLETE_REGISTRATION',
  REGISTERED_BUT_CANNOT_LOG_IN: 'REGISTERED_BUT_CANNOT_LOG_IN',
  REGISTERED_AND_CAN_LOG_IN: 'REGISTERED_AND_CAN_LOG_IN',
};

const stateMap = {
  [states.INCOMPLETE_REGISTRATION]: IncompleteRegistration,
  [states.REGISTERED_BUT_CANNOT_LOG_IN]: AlreadyRegisteredButCannotLogIn,
  [states.REGISTERED_AND_CAN_LOG_IN]: AlreadyRegisteredAndCanLogIn,
};

export function LegacyContactVerificationLanding() {
  const {state, data} = usePhpJs(
    ({legacyContactVerification: {state, data = {}}}) => ({
      state,
      data,
    }),
  );

  const Component = stateMap[state];

  return <Component {...data} />;
}
